import axios from 'axios';
import {
  FETCH_OHLC_SUCCESS,
  FETCH_OHLC_FAIL,
} from './types';

export const fetchOhlc = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/ohlc';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_OHLC_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_OHLC_FAIL, errors: error });
    }

    return dispatch({ type: FETCH_OHLC_FAIL });
  }
};
